require('./brokerHireInvestmentFundContributionsStep.scss');

const PropTypes = require('prop-types');

// @ vendor
const React = require('react');

// @ components
const BlockInfo = require("components/contactCenter/blockInfo/blockInfo");
const OKSelect = require('components/commons/OKSelect/OKSelect');
const DatePickerCustom = require('components/datePickerCustom/datePickerCustom');
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
const { OKButton } = require('components/commons/OKButton/OKButton');
const BrokerInterestModal = require('../brokerInternalTransferFunds/brokerInterestModal/brokerInterestModal');
const { OKMessage } = require('commonsComponents/OKMessage');

// @ commons
const { AmountInput } = require('commonsComponents/amountInput');

// @ helpers
const { FormattedText, formatText, getLanguage } = require('core/i18n').i18n;
const { formatAmountObject, getPlainAmountObject } = require('utilities/currencyHelper');
// @ constants
const { FIRST_STEP, HYPHEN } = require('constants/index');
const {
  DATE_PICKER_CUSTOM_PLACEHOLDER,
  DATE_PICKER_CUSTOM_LOCALE,
  DATE_PICKER_CUSTOM_DATE_FORMAT,
} = require('constants/commonsComponents');
const language = getLanguage();

class BrokerHireInvestmentFundContributionsStep extends React.Component {
  constructor(props) {
    super(props);
    this.handleDateChange = this.handleDateChange.bind(this);
    this.handlePeriodicityChange = this.handlePeriodicityChange.bind(this);
    this.handleClickDeleteAmount = this.handleClickDeleteAmount.bind(this);
    this.handleAmountBlur = this.handleAmountBlur.bind(this);
    this.handleAmountChange = this.handleAmountChange.bind(this);
    this.handleDatePickerError = this.handleDatePickerError.bind(this);
    this.handleToggleModal = this.handleToggleModal.bind(this);
    this.state = {
        showInterestModal: false,
      };
  }

  handleToggleModal() {
    this.setState({ showInterestModal: !this.state.showInterestModal });
  };

  handleDateChange(date) {
    this.props.setValidityDate(date);
  }

  handlePeriodicityChange(value) {
    this.props.setPeriodicity(value);
  }
  handleClickDeleteAmount() {
    this.props.setAmount(0);
  }
  handleAmountBlur(value) {
    this.props.setAmount(value);
  }
  handleAmountChange(value) {
    this.props.setAmount(value);
  }

  handleDatePickerError(error) {
    this.props.setDatePickerError(error);
  }

  buildRemoveIcon() {
    return (
      <span
        onClick={() => this.handleClickDeleteAmount()}
        className="contribution-investment-step1__icon-amount"
      >
        <i class="custom-notification__icon icon-agregar"></i>
      </span>
    );
  }


  buildInput() {
    const { amount, amountErrorState, amountErrorMsg, customMinimumPurchaseAmount } = this.props;
    const currency = customMinimumPurchaseAmount?.get('currency');
    const minimunAmount = customMinimumPurchaseAmount?.get('additionalSubscriptionAmount');
    const plainAmountObject = getPlainAmountObject({ amount: minimunAmount, currency });
    const removeIcon = amount !== 0 ? this.buildRemoveIcon() : null;
    const onlineSymbolObject = currency && minimunAmount ?
                (<OneLineSymbolAmount
                    positiveAmount
                    amountObject={plainAmountObject}
                    language={language}
                    amountObjectFormatted={formatAmountObject(plainAmountObject, true)} />)
                : HYPHEN;

    return (
      <div className="contribution-investment-step1__input-container">
        <FormattedText
            value="brokerContributionFundStep1-amount2"
            className="contribution-investment-step1__associated-cc-amount"
            injectedStrings={[`(${currency.toUpperCase()})`]}
        />
        <div className="contribution-investment-step1__amount-box">
          <div
          >
              <AmountInput
                amount={amount}
                callback={this.handleAmountBlur}
                onChange={this.handleAmountChange}
                error={amountErrorState}
                errorMsg={amountErrorMsg}
                hideFocusZero={true}
                showBlurZero={true}
                language={language}
              />
          </div>
          {removeIcon}
        </div>
        <div className="contribution-investment-step1__associated-cc-minimal">
          <FormattedText
            value={'brokerContributionFundStep1-miniumAmountText1'}
          />
          {onlineSymbolObject}
          <FormattedText
            value={'brokerContributionFundStep1-miniumAmountText2'}
          />
        </div>
      </div>
    );
  }

  getSelectionOptions() {
    const { periodicityOptions } = this.props;
    return periodicityOptions.toJS().map((option) => {
        const label = formatText(option.label);
        return {
            label,
            value: option.value,
        };
    });
  }

  createMonthlyDropdown() {
    const { periodicityError, periodicityValue, periodicityErrorMsg } = this.props;

    return (
      <div className={`contribution-investment-step1__select`}>
        <OKSelect
          label={formatText('brokerContributionFundStep1-priodicityLabel')}
          onChange={this.handlePeriodicityChange}
          options={this.getSelectionOptions()}
          value={periodicityValue}
          autosize={false}
          placeholder={''}
          errorState={periodicityError}
          errorMessage={periodicityErrorMsg}
          searchable={false}
        />
      </div>
    );
  }

  createDatePicker() {
    const { selectedDate, minDate } = this.props;

    return (
      <span className="contribution-investment-step1__date-picker">
        <DatePickerCustom
          callback={this.handleDateChange}
          selectedDate={selectedDate}
          label={formatText('brokerContributionFundStep1-datePickerLabel')}
          placeholder={formatText(DATE_PICKER_CUSTOM_PLACEHOLDER)}
          locale={formatText(DATE_PICKER_CUSTOM_LOCALE)}
          dateFormat={formatText(DATE_PICKER_CUSTOM_DATE_FORMAT)}
          disabled={false}
          minDate={minDate}
          startDate={minDate}
          newSelectedDate={selectedDate}
          callbackError={this.handleDatePickerError}
        />
      </span>
    );
  }

  buildCCTitleInfo() {
    if(__CONTACT_CENTER__) {
        return (
            <BlockInfo extraClass="contribution-investment-step1__block-info-title">
                <FormattedText
                    value={'brokerContributionFundStep1-CCTittleDescription'}
                />
            </BlockInfo>
        )
    }
  }

  buildCCDescriptionInput() {
    if(__CONTACT_CENTER__) {
        return (
            <BlockInfo extraClass="contribution-investment-step1__block-info-input-description">
                <FormattedText
                        value={'brokerContributionFundStep1-CCDescription'}
                    />
            </BlockInfo>
        )
    }
  }

  buildCCDescriptionContribution() {
    if(__CONTACT_CENTER__) {
        return (
            <div className='contribution-investment-step1__block-info-details'>
                <OKMessage type="informative">
                    <FormattedText
                            value={'brokerContributionFundStep1-CCDescriptionContribution'}
                        />
                </OKMessage>
            </div>
        )
    }
  }

  render() {
    const title = formatText('brokerContributionFundStep1-title');

    const inputs = (
      <div className="contribution-investment-step1__periodicly-box">
        {this.buildInput()}
        {this.createMonthlyDropdown()}
        {this.createDatePicker()}
      </div>
    );

    return (
      <div className="contribution-investment-step1">
        <BrokerInterestModal
          isOpen={this.state.showInterestModal}
          onCloseCallback={this.handleToggleModal}
        />
        <header className="contribution-investment-step1__header">
            {this.buildCCTitleInfo()}
          <h2 className="contribution-investment-step1__title">
            {title}
          </h2>
          <FormattedText value="brokerContributionFundStep1-descriptionFirst"/>
          <OKButton modifier="link-emphasize" onClick={this.handleToggleModal}>
            {formatText('brokerContributionFundStep1-descriptionLink')}
          </OKButton>
          <FormattedText value="brokerContributionFundStep1-descriptionSecond"/>
        </header>
        {this.buildCCDescriptionInput()}
        {inputs}
        {this.buildCCDescriptionContribution()}
        <div className="contribution-investment-step1__skip-contribution">
          <OKButton modifier="link-complementary" onClick={() => this.props.skipContribution(true)}>
              {formatText('brokerContributionFundStep1-skipContributionLink')}
          </OKButton>
        </div>
      </div>
    );
  }
}

BrokerHireInvestmentFundContributionsStep.propTypes = {
  customMinimumPurchaseAmount: PropTypes.number,
  amount: PropTypes.number,
  amountErrorState: PropTypes.bool,
  errorMsg: PropTypes.string,
  setAmount: PropTypes.func,
  onClickDeleteAmount: PropTypes.func.isRequired,
  periodicityError: PropTypes.bool,
  periodicityErrorMsg: PropTypes.string,
  periodicityValue: PropTypes.string,
  periodicityOptions: PropTypes.array,
  setPeriodicity: PropTypes.func.isRequired,
  setValidityDate: PropTypes.func.isRequired,
  selectedDate: PropTypes.object,
  minDate: PropTypes.object,
  setDatePickerError: PropTypes.func,
  skipContribution: PropTypes.func.isRequired,
};

module.exports.BrokerHireInvestmentFundContributionsStep = BrokerHireInvestmentFundContributionsStep;
